import { ComponentProps } from 'react';
import { SPACE_150 } from '@alltrails/denali/tokens';
import PaddingAwarePopup from '../../PaddingAwarePopup';
import PopupOffset from '../../../types/PopupOffset';
import { size as startSize } from '../../../utils/svgDefinitions/startSvg';
import { size as endSize } from '../../../utils/svgDefinitions/endSvg';
import { size as startEndSize } from '../../../utils/svgDefinitions/startEndSvg';
import { size as handleSize } from '../../../utils/svgDefinitions/handleSvg';
import ContextMenuContent from './ContextMenuContents';
import styles from './ContextMenu.module.scss';

const getSize = (isStart?: boolean, isEnd?: boolean) => {
  if (isStart && isEnd) {
    return startEndSize;
  }

  if (isStart) {
    return startSize;
  }

  if (isEnd) {
    return endSize;
  }

  return handleSize;
};

const getOffset = (isStart?: boolean, isEnd?: boolean): PopupOffset => {
  const size = getSize(isStart, isEnd);

  const leftHorizontal = size / 2 + SPACE_150;
  const rightHorizontal = size / -2 - SPACE_150;
  const bottomVertical = size / -2 - SPACE_150;
  const topVertical = size / 2 + SPACE_150;

  return {
    bottom: [0, bottomVertical],
    'bottom-left': [leftHorizontal, bottomVertical],
    'bottom-right': [rightHorizontal, bottomVertical],
    top: [0, topVertical],
    'top-left': [leftHorizontal, topVertical],
    'top-right': [rightHorizontal, topVertical],
    left: [leftHorizontal, 0],
    right: [rightHorizontal, 0]
  };
};

type ContextMenuProps = ComponentProps<typeof ContextMenuContent> & {
  latitude: number;
  longitude: number;
};

const ContextMenu = (props: ContextMenuProps) => {
  const { isStart, isEnd, latitude, longitude, onClose } = props;
  return (
    // MaxWidth matches DropdownMenu
    <PaddingAwarePopup
      className={styles.container}
      latitude={latitude}
      longitude={longitude}
      offset={getOffset(isStart, isEnd)}
      maxWidth="320"
      closeButton={false}
      closeOnClick={true}
      focusAfterOpen={true}
      onClose={onClose}
    >
      <ContextMenuContent {...props} />
    </PaddingAwarePopup>
  );
};

export default ContextMenu;
